import React from 'react';
import Head from 'next/head';
import ResumeMatchingKeywords from '../../../components/resume-matching/ResumeMatchingKeywords';

const ResumeWordAnalyzer = props => {
  return (
    <React.Fragment>
      <Head>
        <title>JobsHorn Tools - Resume Word Analyzer</title>
      </Head>
      <div style={{ backgroundColor: '#fafafa' }}>
        <ResumeMatchingKeywords />
      </div>
    </React.Fragment>
  );
};

export default ResumeWordAnalyzer;
